import { Modal, Button as AntButton, DatePicker } from "antd";
import moment from "moment";
import { FC, useEffect, useState } from "react";
import { retireEmployee } from "../../../../api/employees.api";
import useAxios from "../../../../hooks/useAxios";
import useNotification from "../../../../hooks/useNotification";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";
import { useTranslation } from "react-i18next";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  memberCode: string|undefined;
  getStaff: (memberCode: string) => void;
}

const RetireEmployeeModal: FC<IProps> = ({
  visible,
  setVisible,
  memberCode,
  getStaff,
}) => {
  const { t } = useTranslation();
  const { infoNotification } = useNotification();
  const { data: submitRes, isLoading: submitIsLoading, error: submitError, execute: submitExecute } = useAxios();

  const [retireDate, setRetireDate] = useState(moment().format('YYYYMMDD'));

  useEffect(() => {
    if (submitRes && !submitIsLoading) {
      infoNotification(t('campus.staff.3'));
      setVisible(false);
      getStaff(memberCode!);
    }
  }, [submitRes, submitIsLoading]);

  const onSubmit = () => {
    if (!memberCode) return;
    if (!retireDate) {
      return infoNotification(t('campus.staff.4'));
    }

    submitExecute(retireEmployee(memberCode, retireDate));
  };

  return (
    <>
      {submitIsLoading && <Loader />}
      <ErrorResponse error={submitError} />

      <Modal
        title={t('campus.staff.5')}
        visible={visible}
        width={400}
        onCancel={() => setVisible(false)}
        footer={[
          <div className='comm-btn__area justify-content-center'>	
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={onSubmit}
            >
              {t('common.button.save')}
            </AntButton>
            <AntButton
              key="cancel"
              className='btn-basic gray'
              onClick={() => setVisible(false)}
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className="flex flex-justify-center date-picker__area">
          <span className="mr-2">{t('campus.staff.6')}</span>
          <DatePicker
            value={retireDate ? moment(retireDate) : undefined}
            onChange={e => {
              if (e === null) setRetireDate('');
              else setRetireDate(moment(e).format('YYYYMMDD'))
            }}
          />
        </div>
      </Modal>
    </>
  );
};

export default RetireEmployeeModal;
